(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3844],{

/***/ 24915:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/register/journalist",
      function () {
        return __webpack_require__(58970);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 58970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Register; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./styles/modules/Register.module.scss
var Register_module = __webpack_require__(30969);
var Register_module_default = /*#__PURE__*/__webpack_require__.n(Register_module);
// EXTERNAL MODULE: ./next-seo.config.js
var next_seo_config = __webpack_require__(5056);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./api/index.js + 49 modules
var api = __webpack_require__(46979);
// EXTERNAL MODULE: ./data/globalConstants.js
var globalConstants = __webpack_require__(23208);
// EXTERNAL MODULE: ./components/FormWithSidebar.js + 4 modules
var FormWithSidebar = __webpack_require__(31837);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.js
var index_esm = __webpack_require__(42283);
// EXTERNAL MODULE: ./lang/en.json
var en = __webpack_require__(64798);
// EXTERNAL MODULE: ./store/auth.js
var auth = __webpack_require__(32505);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/Register/RegisterJournalist.js














var RegisterJournalist = function(param) {
    var _state = param.state, setFormData = _state.setFormData, formData = _state.formData;
    var ref = (0,index_esm/* useForm */.cI)(), register = ref.register, handleSubmit = ref.handleSubmit, getValues = ref.getValues, errors = ref.errors, setError = ref.setError, setValue = ref.setValue;
    var dispatch = (0,es/* useDispatch */.I0)();
    var router = (0,next_router.useRouter)();
    var error = (0,es/* useSelector */.v9)(auth/* authSelector */.aF).error;
    var ref1 = (0,react.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var email, captchaToken, ref, success, cleanData, res;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        email = data.email, captchaToken = data.captchaToken;
                        return [
                            4,
                            (0,api/* postReq */.qu)("/auth/check-email", {
                                email: email,
                                captchaToken: captchaToken
                            })
                        ];
                    case 1:
                        ref = _state.sent(), success = ref.data.success;
                        if (success) {
                            setError("email", {
                                type: "manual",
                                message: en/* validation.emailExists */.Uf.pI
                            });
                            return [
                                2
                            ];
                        }
                        cleanData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            email: data.email,
                            password: data.password
                        }, router.query), {
                            subscribeMarketing: true
                        }), router.query), {
                            captchaToken: data.captchaToken
                        });
                        return [
                            4,
                            (0,api/* journalistRegistration */.wp)(cleanData)
                        ];
                    case 2:
                        res = _state.sent();
                        if (!res.data || res.data.errors) {
                            return [
                                2,
                                null
                            ];
                        }
                        if (!res.data) return [
                            3,
                            4
                        ];
                        // LOGIN
                        return [
                            4,
                            dispatch((0,auth/* authenticate */.YR)({
                                password: data.password,
                                email: data.email
                            }))
                        ];
                    case 3:
                        _state.sent();
                        if (error) {
                            return [
                                2,
                                console.error(error)
                            ];
                        }
                        dispatch((0,auth/* handleAuthorization */.fy)());
                        setLoading(false);
                        router.push("/");
                        return [
                            3,
                            5
                        ];
                    case 4:
                        console.error(data); // eslint-disable-line
                        _state.label = 5;
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var inputs = [
        {
            type: "email",
            label: "Email address",
            name: "email",
            error: errors["email"],
            register: register({
                required: en/* validation.required */.Uf.C1,
                pattern: {
                    value: globalConstants/* EmailRegEx */._e,
                    message: en/* validation.email */.Uf.Do
                }
            })
        },
        {
            type: "password",
            label: "Password",
            name: "password",
            error: errors["password"],
            register: register({
                required: en/* validation.required */.Uf.C1,
                pattern: {
                    value: globalConstants/* PasswordRegEx */.Pi,
                    message: en/* validation.password */.Uf.Bj
                }
            })
        },
        {
            type: "password",
            label: "Re-type password",
            name: "passwordConfirm",
            error: errors["passwordConfirm"],
            register: register({
                required: en/* validation.required */.Uf.C1,
                validate: function(value) {
                    var password = getValues().password;
                    return password === value || en/* validation.passwordMatch */.Uf.XH;
                }
            })
        },
        {
            type: "hidden",
            name: "captchaToken",
            register: register("captchaToken")
        },
        {
            component: "button",
            title: en/* common.continue */.y0.Jx
        }, 
    ];
    var form = {
        title: "Real time ACCESS TO 000s <br> of REAL BUSINESS OWNERS",
        walkthrough: "Creating a Newspage enables you to get the views of thousands of experts on countless subject matters in minutes, and access to endless case studies.",
        controls: true,
        onSubmit: handleSubmit(onSubmit),
        setValue: setValue,
        inputs: inputs
    };
    var list = en/* registration.screen_1.walkthrough.list.reduce */.l9.n9.ez.pb.reduce(function(acc, item) {
        return acc + "<li>".concat(item, "</li>");
    }, []);
    var quote = {
        quote: '"Newspage has been a lifesaver. It provides me with a fast and straightforward way to connect with experts in their field, who can offer exactly the sort of insights my readers want."',
        author: {
            image: "/tracy_lynn.jpg",
            name: "John Fitzsimmons",
            sub: "Freelance"
        }
    };
    var sidebar = {
        quote: quote,
        topTips: [
            {
                icon: {
                    variant: "small",
                    src: "/icons/top-tips/headlines.svg"
                },
                small: "Top tip",
                title: "Why use Newspage?",
                body: "Newspage gives you a massive diversity of voices to quote in your stories from experts in all corners of the UK. And they appear in one place, in real time."
            }, 
        ]
    };
    var errorsOrdered = inputs.reduce(function(result, item) {
        if (errors[item.name]) {
            result.push(errors[item.name]);
        }
        return result;
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormWithSidebar/* default */.Z, {
        data: {
            form: form,
            sidebar: sidebar,
            errors: errorsOrdered
        }
    });
};
/* harmony default export */ var Register_RegisterJournalist = (RegisterJournalist);

;// CONCATENATED MODULE: ./pages/register/journalist.js








function Register() {
    var ref = (0,react.useState)({
        type: "journalist",
        user: {
            email: null,
            password: null,
            confirmPassword: null
        },
        registered: false
    }), formData = ref[0], setFormData = ref[1];
    var stepToShow;
    if (formData.type && !formData.user.email) {
        stepToShow = /*#__PURE__*/ (0,jsx_runtime.jsx)(Register_RegisterJournalist, {
            state: {
                setFormData: setFormData,
                formData: formData
            }
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, next_seo_config/* default */.Z), {
                titleTemplate: "Register | %s"
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: [
                    "container",
                    (Register_module_default()).pageRegister
                ].join(" "),
                children: stepToShow
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2283,9747,4579,9774,2888,179], function() { return __webpack_exec__(24915); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);